// extracted by mini-css-extract-plugin
export var statItem = "_i3-1";
export var statsRow = "_i3-0";